import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "sync-button" }
const _hoisted_2 = { class: "user-name" }
const _hoisted_3 = { class: "user-email" }
const _hoisted_4 = { class: "user-groups-card-container bg-transparent" }
const _hoisted_5 = { class: "user-groups-select-area" }
const _hoisted_6 = { class: "chip-area" }
const _hoisted_7 = { class: "user-groups-select-area" }
const _hoisted_8 = { class: "chip-area" }
const _hoisted_9 = { class: "user-groups-select-area" }
const _hoisted_10 = { class: "chip-area" }
const _hoisted_11 = { class: "user-groups-btn-container" }
const _hoisted_12 = { class: "user-groups-card-container bg-transparent" }
const _hoisted_13 = { class: "user-groups-btn-container" }
const _hoisted_14 = { class: "user-groups-card-container bg-transparent" }
const _hoisted_15 = { class: "user-groups-btn-container" }
const _hoisted_16 = { class: "user-groups-card-container bg-transparent" }
const _hoisted_17 = { class: "user-groups-btn-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_item_option = _resolveComponent("ion-item-option")!
  const _component_ion_item_options = _resolveComponent("ion-item-options")!
  const _component_ion_item_sliding = _resolveComponent("ion-item-sliding")!
  const _component_ion_accordion = _resolveComponent("ion-accordion")!
  const _component_ion_accordion_group = _resolveComponent("ion-accordion-group")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        class: _normalizeClass([_ctx.isMobile ? 'main-background' : 'liga-web-background']),
        fullscreen: true,
        slot: "fixed",
        "scroll-y": false
      }, {
        default: _withCtx(() => [
          _cache[53] || (_cache[53] = _createElementVNode("h1", { class: "header-title ion-text-center white-bold" }, "Пользователи", -1)),
          _createVNode(_component_ion_item, { class: "user-item-total" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_label, { slot: "start" }, {
                default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                  _createTextVNode("Всего пользователей:", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_ion_label, { slot: "end" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.totalItems), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_button, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.requestUsers())),
                class: "bg-transparent fab-icon",
                slot: "end"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, { icon: _ctx.refreshOutline }, null, 8, ["icon"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_ion_button, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openUserGroupsSelector()))
            }, {
              default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                _createTextVNode("Группы прав", -1)
              ]))]),
              _: 1
            })
          ]),
          _createVNode(_component_ion_searchbar, {
            class: "user-search",
            placeholder: "Поиск",
            inputmode: "text",
            type: "text",
            onIonInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSearchChange($event))),
            debounce: 500
          }),
          _createVNode(_component_ion_item, {
            class: "filter-field-clear-button",
            lines: "none"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_item, {
                class: "filter-field",
                lines: "none"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_select, {
                    label: "Группы прав",
                    modelValue: _ctx.authoritiesFilter,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.authoritiesFilter) = $event)),
                    multiple: true,
                    placeholder: "Не выбрано",
                    "cancel-text": "Отмена",
                    "interface-options": _ctx.customSelectOptions
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allAuthorities, (authority) => {
                        return (_openBlock(), _createBlock(_component_ion_select_option, {
                          key: authority.name,
                          value: authority.name
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(authority.description), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "interface-options"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_icon, {
                slot: "end",
                icon: _ctx.closeOutline,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.clearFilter('authorities')))
              }, null, 8, ["icon"])
            ]),
            _: 1
          }),
          _createVNode(_component_ion_content, { class: "bg-transparent" }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_ion_list, {
                class: "bg-transparent",
                lines: "none"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user, idx) => {
                    return _withDirectives((_openBlock(), _createBlock(_component_ion_item, {
                      key: idx,
                      lines: "none",
                      class: "user-item",
                      onClick: ($event: any) => (_ctx.openUserSettings(user))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { class: "ion-margin-start" }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", _hoisted_2, _toDisplayString(user.lastName) + " " + _toDisplayString(user.firstName), 1),
                            _createElementVNode("p", _hoisted_3, _toDisplayString(user.email), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _withDirectives(_createVNode(_component_ion_button, {
                          onClick: ($event: any) => (_ctx.setActive(user, false)),
                          color: "success"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { class: "button-label" }, {
                              default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                                _createTextVNode("Активный", -1)
                              ]))]),
                              _: 1
                            }),
                            _createVNode(_component_ion_icon, {
                              slot: "end",
                              icon: _ctx.checkmarkOutline,
                              class: "button-icon"
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        }, 8, ["onClick"]), [
                          [_vShow, user.activated]
                        ]),
                        _withDirectives(_createVNode(_component_ion_button, {
                          onClick: ($event: any) => (_ctx.setActive(user, true)),
                          color: "danger"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { class: "button-label" }, {
                              default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                                _createTextVNode("Неактивный", -1)
                              ]))]),
                              _: 1
                            }),
                            _createVNode(_component_ion_icon, {
                              icon: _ctx.closeOutline,
                              class: "button-icon"
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        }, 8, ["onClick"]), [
                          [_vShow, !user.activated]
                        ])
                      ]),
                      _: 2
                    }, 1032, ["onClick"])), [
                      [_vShow, _ctx.filterUsers(user)]
                    ])
                  }), 128)),
                  _createVNode(_component_ion_item, {
                    class: "fake-footer bg-transparent",
                    lines: "none"
                  })
                ]),
                _: 1
              }, 512), [
                [_vShow, _ctx.totalItems > 0]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_ion_modal, {
            "is-open": _ctx.showUserSettings,
            breakpoints: [0, 1],
            initialBreakpoint: 1,
            onIonModalDidDismiss: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showUserSettings = false)),
            onDidDissmiss: _cache[10] || (_cache[10] = ($event: any) => (_ctx.closeUserSettings()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_content, { class: "bg-transparent modal-background" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_header, { class: "user-settings-header" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_toolbar, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_title, { class: "user-settings-header-title" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.selectedUser[0].firstName) + " " + _toDisplayString(_ctx.selectedUser[0].lastName), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_buttons, { slot: "end" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.closeUserSettings())),
                                slot: "end",
                                class: "user-settings-header-button"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    icon: _ctx.closeOutline,
                                    slot: "icon-only"
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, { class: "common-field" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { slot: "start" }, {
                        default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                          _createTextVNode("Логин", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_ion_label, { slot: "end" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.selectedUser[0].login), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, { class: "common-field" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { slot: "start" }, {
                        default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                          _createTextVNode("E-Mail", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_ion_label, { slot: "end" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.selectedUser[0].email), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_accordion_group, { class: "bg-transparent" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_accordion, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, {
                            slot: "header",
                            class: "role-header"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                                  _createTextVNode("Группы прав", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_list, {
                            slot: "content",
                            class: "bg-transparent role-list",
                            lines: "none"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createVNode(_component_ion_item, { class: "role-item add-role-button" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_select, {
                                    label: "Добавить",
                                    multiple: true,
                                    "cancel-text": "Отмена",
                                    onIonChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onCommonAuthoritiesChanged($event))),
                                    "interface-options": _ctx.customSelectOptions
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commonAuthorities, (authority) => {
                                        return (_openBlock(), _createBlock(_component_ion_select_option, {
                                          key: authority.name,
                                          value: authority.name
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(authority.description), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["interface-options"])
                                ]),
                                _: 1
                              }, 512), [
                                [_vShow, _ctx.commonAuthorities.length > 0]
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedUserAuthorities, (authority) => {
                                return (_openBlock(), _createBlock(_component_ion_item_sliding, {
                                  key: authority.name
                                }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createVNode(_component_ion_item, { class: "role-item" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(authority.description), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1536), [
                                      [_vShow, authority.groupId == 1]
                                    ]),
                                    _createVNode(_component_ion_item_options, { side: "end" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_item_option, {
                                          color: "danger",
                                          onClick: ($event: any) => (_ctx.removeAuthority(authority))
                                        }, {
                                          default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                                            _createTextVNode("Удалить", -1)
                                          ]))]),
                                          _: 1
                                        }, 8, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_accordion, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, {
                            slot: "header",
                            class: "role-header"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                                  _createTextVNode("Допуск к программам", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_list, {
                            slot: "content",
                            class: "bg-transparent role-list",
                            lines: "none"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createVNode(_component_ion_item, { class: "role-item add-role-button" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_select, {
                                    label: "Добавить",
                                    multiple: true,
                                    "cancel-text": "Отмена",
                                    onIonChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onProgramAuthoritiesChanged($event))),
                                    "interface-options": _ctx.customSelectOptions
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.programAuthorities, (authority) => {
                                        return (_openBlock(), _createBlock(_component_ion_select_option, {
                                          key: authority.name,
                                          value: authority.name
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(authority.description), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["interface-options"])
                                ]),
                                _: 1
                              }, 512), [
                                [_vShow, _ctx.programAuthorities.length > 0]
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedUserAuthorities, (authority) => {
                                return (_openBlock(), _createBlock(_component_ion_item_sliding, {
                                  key: authority.name
                                }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createVNode(_component_ion_item, { class: "role-item" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(authority.description), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1536), [
                                      [_vShow, authority.groupId == 2]
                                    ]),
                                    _createVNode(_component_ion_item_options, { side: "end" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_item_option, {
                                          color: "danger",
                                          onClick: ($event: any) => (_ctx.removeAuthority(authority))
                                        }, {
                                          default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                                            _createTextVNode("Удалить", -1)
                                          ]))]),
                                          _: 1
                                        }, 8, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_accordion, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, {
                            slot: "header",
                            class: "role-header"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                                  _createTextVNode("Допуск к отдельным релизам", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_list, {
                            slot: "content",
                            class: "bg-transparent role-list",
                            lines: "none"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createVNode(_component_ion_item, { class: "role-item add-role-button" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_select, {
                                    label: "Добавить",
                                    multiple: true,
                                    "cancel-text": "Отмена",
                                    onIonChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onReleaseAuthoritiesChanged($event))),
                                    "interface-options": _ctx.customSelectOptions
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.releaseAuthorities, (release) => {
                                        return (_openBlock(), _createBlock(_component_ion_select_option, {
                                          key: release.id,
                                          value: release
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(release.program ? release.program.programName : '') + " " + _toDisplayString(release.releaseName), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["interface-options"])
                                ]),
                                _: 1
                              }, 512), [
                                [_vShow, _ctx.releaseAuthorities.length > 0]
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedUserReleases, (release) => {
                                return (_openBlock(), _createBlock(_component_ion_item_sliding, {
                                  key: release.id
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_item, { class: "role-item" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(release.program ? release.program.programName : '') + " " + _toDisplayString(release.releaseName), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_ion_item_options, { side: "end" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_item_option, {
                                          color: "danger",
                                          onClick: ($event: any) => (_ctx.removeReleaseAuthority(release))
                                        }, {
                                          default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                                            _createTextVNode("Удалить", -1)
                                          ]))]),
                                          _: 1
                                        }, 8, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["is-open"]),
          _createVNode(_component_ion_modal, {
            "can-dismiss": true,
            onDidDismiss: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showUserGroups = false)),
            "is-open": _ctx.showUserGroups,
            class: "user-groups-modal"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_ion_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_header, { mode: "ios" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_title, null, {
                          default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                            _createTextVNode("Добавление доступа", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_card_content, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_component_ion_label, {
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showAuthoritiesSelector = true))
                          }, {
                            default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                              _createTextVNode("Нажмите для выбора группы прав", -1)
                            ]))]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_6, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedAuthorities, (authority) => {
                              return _withDirectives((_openBlock(), _createBlock(_component_ion_chip, {
                                key: authority.name,
                                color: "primary",
                                mode: "ios",
                                outline: true,
                                onClick: ($event: any) => (
                      _ctx.removeSelectedAuthorities(
                        authority,
                        _ctx.selectedAuthorities,
                        'name'
                      )
                      )
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(authority.description), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_icon, { icon: _ctx.closeOutline }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"])), [
                                [_vShow, _ctx.selectedAuthorities.length > 0]
                              ])
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_ion_label, {
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showReleasesSelector = true))
                          }, {
                            default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                              _createTextVNode("Нажмите для выбора релиза", -1)
                            ]))]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_8, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedReleases, (release) => {
                              return _withDirectives((_openBlock(), _createBlock(_component_ion_chip, {
                                key: release.id,
                                color: "primary",
                                mode: "ios",
                                outline: true,
                                onClick: ($event: any) => (
                      _ctx.removeSelectedReleases(release, _ctx.selectedReleases, 'id')
                      )
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(release.program ? release.program.programName : '') + " " + _toDisplayString(release.releaseName), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_icon, { icon: _ctx.closeOutline }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"])), [
                                [_vShow, _ctx.selectedReleases.length > 0]
                              ])
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_ion_label, {
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showUsersSelector = true))
                          }, {
                            default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                              _createTextVNode("Нажмите для выбора пользователей", -1)
                            ]))]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_10, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedUsers, (user) => {
                              return _withDirectives((_openBlock(), _createBlock(_component_ion_chip, {
                                key: user.id,
                                color: "primary",
                                mode: "ios",
                                outline: true,
                                onClick: ($event: any) => (_ctx.removeSelectedUsers(user, _ctx.selectedUsers, 'id'))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(user.lastName) + " " + _toDisplayString(user.firstName), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_icon, { icon: _ctx.closeOutline }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"])), [
                                [_vShow, _ctx.selectedUsers.length > 0]
                              ])
                            }), 128))
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.acceptUserGroups())),
                        class: "user-groups-accept-button"
                      }, {
                        default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                          _createTextVNode(" Сохранить ", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_ion_button, {
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.dismissUserGroups()))
                      }, {
                        default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                          _createTextVNode(" Отмена ", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["is-open"]),
          _createVNode(_component_ion_modal, {
            "is-open": _ctx.showAuthoritiesSelector,
            class: "user-groups-modal",
            onIonModalDidDismiss: _cache[20] || (_cache[20] = ($event: any) => (_ctx.showAuthoritiesSelector = false))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_ion_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_header, { mode: "ios" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_title, null, {
                          default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                            _createTextVNode("Выбор группы прав", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_searchbar, {
                      class: "user-search",
                      placeholder: "Поиск",
                      inputmode: "text",
                      type: "text",
                      onIonInput: _cache[17] || (_cache[17] = ($event: any) => (_ctx.addAuthoritiesFilter($event))),
                      debounce: 500
                    }),
                    _createVNode(_component_ion_card_content, { class: "list-selector-content" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_list, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allAuthorities, (authority) => {
                              return _withDirectives((_openBlock(), _createBlock(_component_ion_item, {
                                class: _normalizeClass([
                  _ctx.isSelectedByKey(authority, _ctx.selectedAuthorities, 'name')
                    ? 'selected-item'
                    : 'bg-transparent',
                ]),
                                onClick: ($event: any) => (
  _ctx.isSelectedByKey(authority, _ctx.selectedAuthorities, 'name')
    ? _ctx.removeSelectedAuthorities(
      authority,
      _ctx.selectedAuthorities,
      'name'
    )
    : _ctx.addSelection(authority, _ctx.selectedAuthorities)
  ),
                                key: authority.name,
                                value: authority.name
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(authority.description), 1)
                                ]),
                                _: 2
                              }, 1032, ["class", "onClick", "value"])), [
                                [_vShow, _ctx.filterAuthorities(authority)]
                              ])
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.approveAuthoritiesSelector())),
                        class: "user-groups-accept-button"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Добавить " + _toDisplayString(_ctx.selectedAuthorities.length > 0
                  ? `(${_ctx.selectedAuthorities.length})`
                  : ""), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_button, {
                        onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.dismissAuthoritiesSelector()))
                      }, {
                        default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                          _createTextVNode(" Отмена ", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["is-open"]),
          _createVNode(_component_ion_modal, {
            "is-open": _ctx.showReleasesSelector,
            class: "user-groups-modal",
            onIonModalDidDismiss: _cache[24] || (_cache[24] = ($event: any) => (_ctx.showReleasesSelector = false))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_ion_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_header, { mode: "ios" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_title, null, {
                          default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                            _createTextVNode("Выбор релиза", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_searchbar, {
                      class: "user-search",
                      placeholder: "Поиск",
                      inputmode: "text",
                      type: "text",
                      onIonChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.addReleasesFilter($event))),
                      debounce: 500
                    }),
                    _createVNode(_component_ion_card_content, { class: "list-selector-content" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_list, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.releaseAuthorities, (release) => {
                              return _withDirectives((_openBlock(), _createBlock(_component_ion_item, {
                                class: _normalizeClass([
                  _ctx.isSelectedByKey(release, _ctx.selectedReleases, 'id')
                    ? 'selected-item'
                    : 'bg-transparent',
                ]),
                                onClick: ($event: any) => (
  _ctx.isSelectedByKey(release, _ctx.selectedReleases, 'id')
    ? _ctx.removeSelectedReleases(release, _ctx.selectedReleases, 'id')
    : _ctx.addSelection(release, _ctx.selectedReleases)
  ),
                                key: release.id,
                                value: release
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(release.program ? release.program.programName : '') + " " + _toDisplayString(release.releaseName), 1)
                                ]),
                                _: 2
                              }, 1032, ["class", "onClick", "value"])), [
                                [_vShow, _ctx.filterReleases(release)]
                              ])
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.approveReleasesSelector())),
                        class: "user-groups-accept-button"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Добавить " + _toDisplayString(_ctx.selectedReleases.length > 0
                  ? `(${_ctx.selectedReleases.length})`
                  : ""), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_button, {
                        onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.dismissReleasesSelector()))
                      }, {
                        default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                          _createTextVNode(" Отмена ", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["is-open"]),
          _createVNode(_component_ion_modal, {
            "is-open": _ctx.showUsersSelector,
            class: "user-groups-modal",
            onIonModalDidDismiss: _cache[28] || (_cache[28] = ($event: any) => (_ctx.showUsersSelector = false))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_ion_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_header, { mode: "ios" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_title, null, {
                          default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                            _createTextVNode("Выбор пользователей", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_searchbar, {
                      class: "user-search",
                      placeholder: "Поиск",
                      inputmode: "text",
                      type: "text",
                      onIonInput: _cache[25] || (_cache[25] = ($event: any) => (_ctx.onSearchChange($event))),
                      debounce: 500
                    }),
                    _createVNode(_component_ion_card_content, { class: "list-selector-content" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_list, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
                              return _withDirectives((_openBlock(), _createBlock(_component_ion_item, {
                                class: _normalizeClass([
                  _ctx.isSelectedByKey(user, _ctx.selectedUsers, 'id')
                    ? 'selected-item'
                    : 'bg-transparent',
                ]),
                                onClick: ($event: any) => (
  _ctx.isSelectedByKey(user, _ctx.selectedUsers, 'id')
    ? _ctx.removeSelectedUsers(user, _ctx.selectedUsers, 'id')
    : _ctx.addSelection(user, _ctx.selectedUsers)
  ),
                                key: user.id,
                                value: user
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(user.lastName) + " " + _toDisplayString(user.firstName), 1)
                                ]),
                                _: 2
                              }, 1032, ["class", "onClick", "value"])), [
                                [_vShow, _ctx.filterUsers(user)]
                              ])
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.approveUsersSelector())),
                        class: "user-groups-accept-button"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Добавить " + _toDisplayString(_ctx.selectedUsers.length > 0 ? `(${_ctx.selectedUsers.length})` : ""), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_button, {
                        onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.dismissUsersSelector()))
                      }, {
                        default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                          _createTextVNode(" Отмена ", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["is-open"])
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 1
  }))
}